import * as React from 'react';

type Features = {
  newColorsBranding?: boolean;
  sidebarExperimentCollapsible?: boolean;
};

type Theme = {
  className?: string;
};

export interface WixStyleReactProviderProps extends React.HTMLAttributes<any> {
  dataHook?: string;
  className?: string;
  as?: 'span' | 'div';
  children?: React.ReactNode;
  features?: Features;
  theme?: Theme;
}

export default class WixStyleReactProvider extends React.PureComponent<WixStyleReactProviderProps> {}
